import React, { createContext, useState, useContext } from 'react';

import ModalRoot from '@/components/Modals/RootModal';

export const ModalContext = createContext();

export const ModalContextProvider = ({ children }) => {

  const [modalType, setModalType] = useState(null);
  const [modalProps, setModalProps] = useState({});

  return (
    <ModalContext.Provider value={{ setModalType, setModalProps, modalType, modalProps }}>
      {children}
    </ModalContext.Provider>
  );


};

export const useModalContext = () => useContext(ModalContext);
